package com.bikompanion.ui.composables

internal const val STATIONS_VISIBLE_ZOOM = 11.0

/**
 * Where bike racks stop being clustered and start being drawn one by one.
 *
 * Racks are two orders of magnitude denser than stations — a European city block can carry a
 * dozen, and one loaded cell holds up to ten thousand — so they need a threshold of their own
 * rather than the station one. Below this, drawing them individually was both illegible, a smear
 * of overlapping 6dp dots, and genuinely slow: every rack in view costs a projection through the
 * map, which on Android is a JNI call, and there were thousands of them per dragged frame.
 *
 * Above it a screenful is a few hundred racks at most, which draws comfortably.
 */
internal const val PARKING_SPOTS_ZOOM = 14.0

/**
 * Where a station stops being a plain dot and becomes a ring carrying its numbers.
 *
 * A clean switch rather than a ramp: below this there isn't room to read a count off a
 * marker, so the dot says only what it can — whether the station has e-bikes.
 */
internal const val STATIONS_PIE_ZOOM = 15.0

// Names appear only once the map is close enough that neighbouring stations sit far enough
// apart for their labels not to overlap. A clean switch rather than a ramp: a half-faded
// label lying over the next station's ring reads as clutter either way.
internal const val STATION_NAMES_VISIBLE_ZOOM = 17.5

internal fun showStationNamesAt(zoom: Double) = zoom >= STATION_NAMES_VISIBLE_ZOOM
